(() => {
  if (window.__tanHospitalityFinderAssetReady) {
    window.dispatchEvent(new CustomEvent('tan:hospitality-finder:init'));
    return;
  }
  window.__tanHospitalityFinderAssetReady = true;

  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const interpolate = (template, values = {}) => Object.entries(values).reduce(
    (output, [key, value]) => output.split(`{${key}}`).join(String(value)),
    String(template || ''),
  );

  const initializeRoot = (root) => {
    if (!root || root.dataset.hospitalityFinderReady) return;
    root.dataset.hospitalityFinderReady = 'true';

    let i18n = {};
    try {
      i18n = JSON.parse(root.querySelector('[data-tan-hospitality-copy]')?.textContent || '{}');
    } catch (_) {
      i18n = {};
    }

    const choices = Array.from(root.querySelectorAll('[data-hospitality-choice]'));
    const heading = root.querySelector('[data-hospitality-result-heading]');
    const resultCopy = root.querySelector('[data-hospitality-result-copy]');
    const goalList = root.querySelector('[data-hospitality-goal-list]');
    const placeList = root.querySelector('[data-hospitality-place-list]');
    const primary = root.querySelector('[data-hospitality-primary]');
    const secondary = root.querySelector('[data-hospitality-secondary]');
    const briefOutput = root.querySelector('[data-tan-brief-output]');

    const activeChoice = (group) =>
      root.querySelector(`[data-hospitality-choice][data-choice-group="${group}"].is-active`);

    const payloadFor = (choice) =>
      Array.from(root.querySelectorAll('[data-hospitality-payload]')).find(
        (payload) => payload.dataset.hospitalityPayload === choice.dataset.choiceId,
      );

    const copyChecklist = (choice, target) => {
      if (!choice || !target) return;
      const payload = payloadFor(choice);
      const content = payload && payload.content.querySelector('[data-choice-checklist]');
      target.innerHTML = content ? content.innerHTML : '';
    };

    const update = () => {
      const goal = activeChoice('goal');
      const place = activeChoice('place');
      if (!goal || !place || !heading || !resultCopy) return;

      heading.textContent = [goal.dataset.choiceTitle, place.dataset.choiceTitle].join(i18n.headingSeparator || '');
      resultCopy.textContent = [goal.dataset.choiceNote, place.dataset.choiceNote].filter(Boolean).join(' ');
      copyChecklist(goal, goalList);
      copyChecklist(place, placeList);

      const placeOverrides = place.dataset.overrideCta === 'true' && place.dataset.ctaLink;
      const primarySource = placeOverrides ? place : goal;
      if (primary) {
        primary.textContent = primarySource.dataset.ctaLabel || i18n.defaultCta || '';
        primary.href = primarySource.dataset.ctaLink || '#';
        primary.hidden = !primarySource.dataset.ctaLink;
      }

      if (secondary) {
        secondary.textContent = place.dataset.guideLabel || '';
        secondary.href = place.dataset.guideLink || '#';
        secondary.hidden = !place.dataset.guideLink || !place.dataset.guideLabel;
      }

      if (briefOutput) {
        const goalDetails = Array.from(goalList?.querySelectorAll('li') || []).map((item) => clean(item.textContent)).filter(Boolean);
        const placeDetails = Array.from(placeList?.querySelectorAll('li') || []).map((item) => clean(item.textContent)).filter(Boolean);
        briefOutput.value = [
          i18n.brief?.title,
          interpolate(i18n.brief?.businessGoal, { value: clean(goal.dataset.choiceTitle) }),
          interpolate(i18n.brief?.placement, { value: clean(place.dataset.choiceTitle) }),
          '',
          interpolate(i18n.brief?.planningDirection, { value: clean(resultCopy.textContent) }),
          '',
          interpolate(i18n.brief?.goalPriorities, { value: goalDetails.join(i18n.listSeparator || '') }),
          interpolate(i18n.brief?.placementDetails, { value: placeDetails.join(i18n.listSeparator || '') }),
          '',
          i18n.brief?.attachments,
        ].join('\n');
      }
    };

    choices.forEach((choice) => {
      choice.addEventListener('click', () => {
        choices
          .filter((candidate) => candidate.dataset.choiceGroup === choice.dataset.choiceGroup)
          .forEach((candidate) => {
            const selected = candidate === choice;
            candidate.classList.toggle('is-active', selected);
            candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        update();
      });
    });

    update();
  };

  const initialize = (scope = document) => {
    if (scope.matches?.('[data-tan-hospitality-finder]')) initializeRoot(scope);
    scope.querySelectorAll?.('[data-tan-hospitality-finder]').forEach(initializeRoot);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('tan:hospitality-finder:init', () => initialize());
})();
